module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/flash-back-video.085efbc9.webm";